import { Directive, TemplateRef, Component, Input, ContentChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * 自定义模板
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxTimelineComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "date");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, event_r1.date, ctx_r3.dateFormat));
} }
function NgxTimelineComponent_div_1_3_ng_template_0_Template(rf, ctx) { }
const _c0 = function (a0, a1) { return { $implicit: a0, rowIndex: a1 }; };
function NgxTimelineComponent_div_1_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxTimelineComponent_div_1_3_ng_template_0_Template, 0, 0, "ng-template", 11);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const event_r1 = ctx_r13.$implicit;
    const i_r2 = ctx_r13.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.dateTemplate.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c0, event_r1, i_r2));
} }
function NgxTimelineComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(event_r1.header);
} }
function NgxTimelineComponent_div_1_9_ng_template_0_Template(rf, ctx) { }
function NgxTimelineComponent_div_1_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxTimelineComponent_div_1_9_ng_template_0_Template, 0, 0, "ng-template", 11);
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext();
    const event_r1 = ctx_r16.$implicit;
    const i_r2 = ctx_r16.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r6.headerTemplate.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c0, event_r1, i_r2));
} }
function NgxTimelineComponent_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(event_r1.body);
} }
function NgxTimelineComponent_div_1_12_ng_template_0_Template(rf, ctx) { }
function NgxTimelineComponent_div_1_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxTimelineComponent_div_1_12_ng_template_0_Template, 0, 0, "ng-template", 11);
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext();
    const event_r1 = ctx_r19.$implicit;
    const i_r2 = ctx_r19.index;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r8.bodyTemplate.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c0, event_r1, i_r2));
} }
function NgxTimelineComponent_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(event_r1.footer);
} }
function NgxTimelineComponent_div_1_15_ng_template_0_Template(rf, ctx) { }
function NgxTimelineComponent_div_1_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxTimelineComponent_div_1_15_ng_template_0_Template, 0, 0, "ng-template", 11);
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext();
    const event_r1 = ctx_r22.$implicit;
    const i_r2 = ctx_r22.index;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.footerTemplate.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c0, event_r1, i_r2));
} }
const _c1 = function (a0) { return { "hide-border": a0 }; };
function NgxTimelineComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, NgxTimelineComponent_div_1_div_2_Template, 3, 4, "div", 4);
    ɵngcc0.ɵɵtemplate(3, NgxTimelineComponent_div_1_3_Template, 1, 5, null, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelement(5, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7)(7, "div", 8);
    ɵngcc0.ɵɵtemplate(8, NgxTimelineComponent_div_1_div_8_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(9, NgxTimelineComponent_div_1_9_Template, 1, 5, null, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵtemplate(11, NgxTimelineComponent_div_1_div_11_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(12, NgxTimelineComponent_div_1_12_Template, 1, 5, null, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 10);
    ɵngcc0.ɵɵtemplate(14, NgxTimelineComponent_div_1_div_14_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(15, NgxTimelineComponent_div_1_15_Template, 1, 5, null, 4);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const event_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.dateTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.dateTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c1, event_r1.icon));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", event_r1.icon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.headerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.headerTemplate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.bodyTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.bodyTemplate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.footerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerTemplate);
} }
class TimelineDate {
    /**
     * @param {?} templateRef
     */
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TimelineDate.ɵfac = function TimelineDate_Factory(t) { return new (t || TimelineDate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TimelineDate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TimelineDate, selectors: [["ng-template", "timelineDate", ""]] });
/** @nocollapse */
TimelineDate.ctorParameters = () => [
    { type: TemplateRef, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimelineDate, [{
        type: Directive,
        args: [{ selector: 'ng-template[timelineDate]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class TimelineHeader {
    /**
     * @param {?} templateRef
     */
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TimelineHeader.ɵfac = function TimelineHeader_Factory(t) { return new (t || TimelineHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TimelineHeader.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TimelineHeader, selectors: [["ng-template", "timelineHeader", ""]] });
/** @nocollapse */
TimelineHeader.ctorParameters = () => [
    { type: TemplateRef, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimelineHeader, [{
        type: Directive,
        args: [{ selector: 'ng-template[timelineHeader]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class TimelineBody {
    /**
     * @param {?} templateRef
     */
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TimelineBody.ɵfac = function TimelineBody_Factory(t) { return new (t || TimelineBody)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TimelineBody.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TimelineBody, selectors: [["ng-template", "timelineBody", ""]] });
/** @nocollapse */
TimelineBody.ctorParameters = () => [
    { type: TemplateRef, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimelineBody, [{
        type: Directive,
        args: [{ selector: 'ng-template[timelineBody]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
class TimelineFooter {
    /**
     * @param {?} templateRef
     */
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
TimelineFooter.ɵfac = function TimelineFooter_Factory(t) { return new (t || TimelineFooter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
TimelineFooter.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TimelineFooter, selectors: [["ng-template", "timelineFooter", ""]] });
/** @nocollapse */
TimelineFooter.ctorParameters = () => [
    { type: TemplateRef, },
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimelineFooter, [{
        type: Directive,
        args: [{ selector: 'ng-template[timelineFooter]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxTimelineComponent {
    constructor() {
        this.dateFormat = 'yyyy-MM-dd';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
NgxTimelineComponent.ɵfac = function NgxTimelineComponent_Factory(t) { return new (t || NgxTimelineComponent)(); };
NgxTimelineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTimelineComponent, selectors: [["ngx-timeline"]], contentQueries: function NgxTimelineComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TimelineDate, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TimelineHeader, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TimelineBody, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, TimelineFooter, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dateTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bodyTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
    } }, inputs: { dateFormat: "dateFormat", events: "events", timelineClass: "timelineClass", timelineStyle: "timelineStyle" }, decls: 2, vars: 3, consts: [[1, "timeline", 3, "ngClass", "ngStyle"], ["class", "timeline-item", 4, "ngFor", "ngForOf"], [1, "timeline-item"], [1, "timeline-date"], [4, "ngIf"], [1, "timeline-point", 3, "ngClass"], [1, "fa", 3, "ngClass"], [1, "timeline-event"], [1, "timeline-header"], [1, "timeline-body"], [1, "timeline-footer"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function NgxTimelineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxTimelineComponent_div_1_Template, 16, 12, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.timelineClass)("ngStyle", ctx.timelineStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.events);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc1.DatePipe], styles: [".timeline[_ngcontent-%COMP%]{position:relative}.timeline[_ngcontent-%COMP%]::before{position:absolute;width:2px;height:100%;top:0;left:50%;margin-left:-1px;background-color:#ccc;content:\" \"}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]{position:relative;margin:1rem 0}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-date[_ngcontent-%COMP%]{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;top:10px;left:55%;line-height:30px;width:45%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-point[_ngcontent-%COMP%]{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;left:50%;top:10px;margin-left:-15px;border:1px solid #ccc;border-radius:100%;text-align:center;background-color:#fff;z-index:99;font-size:30px;height:30px;line-height:30px;width:30px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-point.hide-border[_ngcontent-%COMP%]{border:none}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;left:0;width:45%;padding:1rem;border:1px solid #ccc;background-color:#fff;border-radius:5px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::after, .timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::before{position:absolute;left:100%;top:10px;content:\" \";height:0;width:0;border:15px solid transparent;border-left-color:#fff}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::before{border-left-color:#ccc;margin-left:1px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]   .timeline-header[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:500}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]   .timeline-body[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:1rem;color:#666}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-date[_ngcontent-%COMP%]{left:0;text-align:right}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]{left:55%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::after, .timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::before{border-right-color:#ccc;margin-left:-31px}@media (max-width:768px){.timeline[_ngcontent-%COMP%]::before{left:2%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]{padding-top:30px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-date[_ngcontent-%COMP%]{top:0;left:7%;width:100%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-point[_ngcontent-%COMP%]{left:2%;top:40px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]{left:7%;width:93%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::after, .timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]   .timeline-event[_ngcontent-%COMP%]::before{border-right-color:#ccc;margin-left:-31px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-date[_ngcontent-%COMP%]{text-align:left;left:7%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]{left:7%}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::after, .timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline[_ngcontent-%COMP%]   .timeline-item[_ngcontent-%COMP%]:nth-child(even)   .timeline-event[_ngcontent-%COMP%]::before{border-right-color:#ccc;margin-left:-31px}}"] });
/** @nocollapse */
NgxTimelineComponent.ctorParameters = () => [];
NgxTimelineComponent.propDecorators = {
    "events": [{ type: Input },],
    "timelineClass": [{ type: Input },],
    "timelineStyle": [{ type: Input },],
    "dateFormat": [{ type: Input },],
    "dateTemplate": [{ type: ContentChild, args: [TimelineDate,] },],
    "headerTemplate": [{ type: ContentChild, args: [TimelineHeader,] },],
    "bodyTemplate": [{ type: ContentChild, args: [TimelineBody,] },],
    "footerTemplate": [{ type: ContentChild, args: [TimelineFooter,] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTimelineComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-timeline',
                template: `<div class="timeline" [ngClass]="timelineClass" [ngStyle]="timelineStyle">
  <div class="timeline-item" *ngFor="let event of events; index as i">
    <div class="timeline-date">
      <div *ngIf="!dateTemplate">{{event.date | date: dateFormat}}</div>
      <ng-template *ngIf="dateTemplate" [ngTemplateOutlet]="dateTemplate.templateRef" [ngTemplateOutletContext]="{ $implicit: event, rowIndex: i }"></ng-template>
    </div>
    <div class="timeline-point" [ngClass]="{'hide-border': event.icon}">
      <i class="fa" [ngClass]="event.icon"></i>
    </div>
    <div class="timeline-event">
      <div class="timeline-header">
        <div *ngIf="!headerTemplate">{{event.header}}</div>
        <ng-template *ngIf="headerTemplate" [ngTemplateOutlet]="headerTemplate.templateRef" [ngTemplateOutletContext]="{ $implicit: event, rowIndex: i }"></ng-template>
      </div>
      <div class="timeline-body">
        <div *ngIf="!bodyTemplate">{{event.body}}</div>
        <ng-template *ngIf="bodyTemplate" [ngTemplateOutlet]="bodyTemplate.templateRef" [ngTemplateOutletContext]="{ $implicit: event, rowIndex: i }"></ng-template>
      </div>
      <div class="timeline-footer">
        <div *ngIf="!footerTemplate">{{event.footer}}</div>
        <ng-template *ngIf="footerTemplate" [ngTemplateOutlet]="footerTemplate.templateRef" [ngTemplateOutletContext]="{ $implicit: event, rowIndex: i }"></ng-template>
      </div>
    </div>
  </div>
</div>`,
                styles: [`.timeline{position:relative}.timeline::before{position:absolute;width:2px;height:100%;top:0;left:50%;margin-left:-1px;background-color:#ccc;content:" "}.timeline .timeline-item{position:relative;margin:1rem 0}.timeline .timeline-item .timeline-date{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;top:10px;left:55%;line-height:30px;width:45%}.timeline .timeline-item .timeline-point{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;left:50%;top:10px;margin-left:-15px;border:1px solid #ccc;border-radius:100%;text-align:center;background-color:#fff;z-index:99;font-size:30px;height:30px;line-height:30px;width:30px}.timeline .timeline-item .timeline-point.hide-border{border:none}.timeline .timeline-item .timeline-event{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;left:0;width:45%;padding:1rem;border:1px solid #ccc;background-color:#fff;border-radius:5px}.timeline .timeline-item .timeline-event::after,.timeline .timeline-item .timeline-event::before{position:absolute;left:100%;top:10px;content:" ";height:0;width:0;border:15px solid transparent;border-left-color:#fff}.timeline .timeline-item .timeline-event::before{border-left-color:#ccc;margin-left:1px}.timeline .timeline-item .timeline-event .timeline-header{font-size:1.5rem;font-weight:500}.timeline .timeline-item .timeline-event .timeline-body{margin-top:1rem;margin-bottom:1rem;color:#666}.timeline .timeline-item:nth-child(even) .timeline-date{left:0;text-align:right}.timeline .timeline-item:nth-child(even) .timeline-event{left:55%}.timeline .timeline-item:nth-child(even) .timeline-event::after,.timeline .timeline-item:nth-child(even) .timeline-event::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline .timeline-item:nth-child(even) .timeline-event::before{border-right-color:#ccc;margin-left:-31px}@media (max-width:768px){.timeline::before{left:2%}.timeline .timeline-item{padding-top:30px}.timeline .timeline-item .timeline-date{top:0;left:7%;width:100%}.timeline .timeline-item .timeline-point{left:2%;top:40px}.timeline .timeline-item .timeline-event{left:7%;width:93%}.timeline .timeline-item .timeline-event::after,.timeline .timeline-item .timeline-event::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline .timeline-item .timeline-event::before{border-right-color:#ccc;margin-left:-31px}.timeline .timeline-item:nth-child(even) .timeline-date{text-align:left;left:7%}.timeline .timeline-item:nth-child(even) .timeline-event{left:7%}.timeline .timeline-item:nth-child(even) .timeline-event::after,.timeline .timeline-item:nth-child(even) .timeline-event::before{left:0;border-left-color:transparent!important;border-right-color:#fff;margin-left:-30px}.timeline .timeline-item:nth-child(even) .timeline-event::before{border-right-color:#ccc;margin-left:-31px}}`]
            }]
    }], function () { return []; }, { dateFormat: [{
            type: Input
        }], events: [{
            type: Input
        }], timelineClass: [{
            type: Input
        }], timelineStyle: [{
            type: Input
        }], dateTemplate: [{
            type: ContentChild,
            args: [TimelineDate]
        }], headerTemplate: [{
            type: ContentChild,
            args: [TimelineHeader]
        }], bodyTemplate: [{
            type: ContentChild,
            args: [TimelineBody]
        }], footerTemplate: [{
            type: ContentChild,
            args: [TimelineFooter]
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxTimelineModule {
}
NgxTimelineModule.ɵfac = function NgxTimelineModule_Factory(t) { return new (t || NgxTimelineModule)(); };
NgxTimelineModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxTimelineModule });
NgxTimelineModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
/** @nocollapse */
NgxTimelineModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTimelineModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    NgxTimelineComponent,
                    TimelineDate,
                    TimelineHeader,
                    TimelineBody,
                    TimelineFooter
                ],
                exports: [
                    NgxTimelineComponent,
                    TimelineDate,
                    TimelineHeader,
                    TimelineBody,
                    TimelineFooter
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxTimelineModule, { declarations: function () { return [NgxTimelineComponent, TimelineDate, TimelineHeader, TimelineBody, TimelineFooter]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxTimelineComponent, TimelineDate, TimelineHeader, TimelineBody, TimelineFooter]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { NgxTimelineModule, NgxTimelineComponent as ɵa, TimelineBody as ɵd, TimelineDate as ɵb, TimelineFooter as ɵe, TimelineHeader as ɵc };

